// Error monitoring (Sentry) — privacy-first.
// - Attivo SOLO se REACT_APP_SENTRY_DSN è configurata (altrimenti no-op).
// - NON invia PII: sendDefaultPii=false + beforeSend che rimuove email/token/
//   Authorization e query string dagli eventi.
import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;

const scrub = (str) => {
  if (typeof str !== 'string') return str;
  return str
    .replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[email]')
    .replace(/(Bearer|apikey|access_token|token)=?\s*[A-Za-z0-9._-]{8,}/gi, '$1 [redacted]');
};

export const initMonitoring = () => {
  if (!DSN) return; // nessun DSN → monitoring disattivato
  try {
    Sentry.init({
      dsn: DSN,
      environment: process.env.NODE_ENV,
      release: process.env.REACT_APP_COMMIT || 'dev',
      sendDefaultPii: false,
      tracesSampleRate: 0, // solo errori, nessun performance tracing (niente PII, meno quota)
      beforeSend(event) {
        // Rimuovi dati potenzialmente sensibili
        if (event.request) {
          delete event.request.cookies;
          if (event.request.headers) {
            delete event.request.headers.Authorization;
            delete event.request.headers.apikey;
          }
          if (event.request.url) event.request.url = event.request.url.split('?')[0];
        }
        if (event.user) {
          // Tieni solo un id opaco, mai email/username
          event.user = event.user.id ? { id: event.user.id } : undefined;
        }
        if (event.message) event.message = scrub(event.message);
        return event;
      },
    });
  } catch (e) {
    // il monitoring non deve mai rompere l'app
    console.warn('[MONITORING] init fallito:', e.message);
  }
};
